module.exports = __webpack_public_path__ + "img/Postmodernisme_Tida_og_samfunnsforhold6.a3f557ee.jpg";